import {
    CLEAN_CLINIC,
    EDIT_CLINIC,
    FILTER_CLINICSDATA,
    NEW_CLINIC,
    CLINICS_COUNT,
    CLINICS_DATA,
    CLINICS_SELECTION,
    DELETE_CLINIC,
} from "../../constants/Tabs-Action-Types";
import utils from "../../../utils/utils";


const initialState = {
    initiateClinicData:[],
    clinicData:[],
    clinicTableFilter:{},
    clinicsCount: 0
};

const clinicTableDataReducer = (state = initialState, action)=> {

    switch(action.type){

        case CLINICS_COUNT:{
            let _idata = JSON.parse(JSON.stringify(action.payload));
            state = {
                ...state,
               clinicsCount: _idata
            };
            break;
        }
        case CLINICS_DATA:
            let collection = []
            action.payload.forEach(clinic =>{
                collection.push({
                    id:clinic.Clinic_ID,
                    Clinic_ID: clinic.Clinic_ID,
                    Clinic_Name: clinic.Clinic_Name,
                    Clinic_Mail: clinic.Clinic_Mail,
                    Clinic_PictureURL: clinic.Clinic_PictureURL,
                    Clinic_Address: clinic.Clinic_Address,
                    Clinic_Code: clinic.Clinic_Code,
                    Is_Approving_Clinic: clinic.Is_Approving_Clinic,
                    Clinic_Info: clinic.Clinic_Info,

                    LinkedHCPs: clinic.NumOfHCP,

/*
                    Clinic_Mail: clinic.Clinic_Mail,
                    ClinicState: clinic.ClinicState,
 */
                    Enabled: true,
                   /* Clinic_Country: clinic.Clinic_Country,
                    Clinic_City: clinic.Clinic_City,
                    Clinic_Street: clinic.Clinic_Street,
                    Clinic_Apartment: clinic.Clinic_Apartment,
                    Clinic_Phone_num: clinic.Clinic_Phone_num,*/
                    HCPs: clinic.HCPs,
                })
            })

            let _pdata = JSON.parse(JSON.stringify(collection));
            state = {
                ...state,
                initiateClinicData:_pdata,
                clinicData : _pdata,
                clinicsCount: collection.length
            };
            break;
        case CLEAN_CLINIC:{
            state = {
                ...state,
                clinicTableFilter: {}
            };
            break;
        }

        case DELETE_CLINIC: {

            let clinicId = action.id

            let clinicData = state.clinicData
            let initiateClinicData = state.initiateClinicData


            let newclinicData = clinicData.filter(clinic => clinic.Clinic_ID !== clinicId)
            let newinitiateClinicData = initiateClinicData.filter(clinic => clinic.Clinic_ID !== clinicId)

            let _pdata = JSON.parse(JSON.stringify(newclinicData));
            let _idata = JSON.parse(JSON.stringify(newinitiateClinicData));

            state = {
                ...state,
                initiateClinicData:_idata,
                clinicData : _pdata,
                clinicsCount: newinitiateClinicData.length
            };
            break;
        }
        case FILTER_CLINICSDATA:{
            let type = action.searchType
            let payload = action.payload
            let clinicTableFilter = state.clinicTableFilter
            let filteredClinicsData = state.initiateClinicData
            let visibleFilterData = []
            let visiableData = []

            if (type === 'search' && (payload === '' || payload === null)){
                delete clinicTableFilter.search
            } else {
                utils.set(clinicTableFilter,type,payload)
            }

            for (const [key, value] of Object.entries(clinicTableFilter)) {
                if (key === 'search'){
                    let val = value.toLowerCase()
                    filteredClinicsData = filteredClinicsData.filter(x =>
                        String(x.Clinic_Name).toLowerCase().indexOf(val) > -1 ||
                        String(x.LinkedHCPs).toLowerCase().indexOf(val) > -1 ||
                        String(x.Clinic_Mail).toLowerCase().indexOf(val) > -1 ||
                        String(x.Clinic_Phone_num).toLowerCase().indexOf(val) > -1
                    )
                    visibleFilterData = filteredClinicsData
                } else {
                    let clinics = JSON.parse(JSON.stringify(filteredClinicsData))
                    let valArr = JSON.parse(JSON.stringify(value))

                    if (Array.isArray(valArr)){
                        let res = []
                        valArr.forEach(val => {
                            let clinicArr = clinics.filter(clinic => {
                                let clinicVal = clinic[key]
                                return String(clinicVal).toLowerCase() === String(val).toLowerCase()
                            })
                            clinicArr.forEach(clinic => res.push(clinic))
                        })
                        filteredClinicsData = res
                    }
                }
            }
            visiableData = filteredClinicsData

            let _fpdata = JSON.parse(JSON.stringify(visibleFilterData));
            let _vdata = JSON.parse(JSON.stringify(visiableData));
            let _pfdata = JSON.parse(JSON.stringify(clinicTableFilter));
            state = {
                ...state,
                filteredClinicsData: _fpdata,
                clinicData: _vdata,
                clinicTableFilter: _pfdata
            };
            break;
        }
        case CLINICS_SELECTION:{
            let selection = action.payload
            let initiateClinicData = state.initiateClinicData

            let newSelection = []
            Object.entries(selection).forEach(([key,value]) => {
                if (value){
                    let index = initiateClinicData.findIndex((obj => obj.Clinic_ID === key));
                    let name = initiateClinicData[index].Clinic_Name
                    newSelection.push({id:key,name})
                }
            })
            state = {
                ...state,
                selectedClinicData: newSelection
            };
            break;
        }
        case NEW_CLINIC:{
            let clinic = action.payload
            let clinicData = state.clinicData
            let initiateClinicData = state.initiateClinicData

            let newData = [{
                id:clinic.Clinic_ID,
                Clinic_ID: clinic.Clinic_ID,
                Clinic_Name: clinic.Clinic_Name,
                Clinic_Mail: clinic.Clinic_Mail,
                LinkedHCPs: clinic.HCPs?clinic.HCPs.length:0,
                Clinic_Address: clinic.Clinic_Address,
                Clinic_Info: clinic.Clinic_Info,
                Clinic_PictureURL: clinic.Clinic_PictureURL,
                Clinic_Code: clinic.Clinic_Code,
                Is_Approving_Clinic: clinic.Is_Approving_Clinic,
                Enabled: true,
     /*           Clinic_Country: clinic.Clinic_Country,
                Clinic_State: clinic.Clinic_State,
                Clinic_City: clinic.Clinic_City,
                ClinicState: clinic.ClinicState,
                Clinic_Street: clinic.Clinic_Street,
                Clinic_Apartment: clinic.Clinic_Apartment?clinic.Clinic_Apartment:clinic.Apartment,*/
                Clinic_Phone_num: clinic.Clinic_Phone_num,
                AccountStatus: clinic.AccountStatus,
                HCPs: clinic.HCPs,
            }]
            let newclinicData = clinicData.concat(newData)
            let newinitiateClinicData = initiateClinicData.concat(newData)
            let _pdata = JSON.parse(JSON.stringify(newclinicData));
            let _idata = JSON.parse(JSON.stringify(newinitiateClinicData));
            state = {
                ...state,
                initiateClinicData:_idata,
                clinicData : _pdata,
                clinicsCount: newinitiateClinicData.length
            };
            break;
        }
        case EDIT_CLINIC: {
            let clinic = action.payload
            let clinicData = state.clinicData
            let initiateClinicData = state.initiateClinicData

            let indexData = clinicData.findIndex((obj => obj.id === clinic.id));
            let indexInit = initiateClinicData.findIndex((obj => obj.id === clinic.id));

            clinicData[indexData]['Clinic_Name'] = clinic.Clinic_Name
            clinicData[indexData]['Clinic_Phone_num'] = clinic.Clinic_Phone_num
            clinicData[indexData]['Clinic_Mail'] = clinic.Clinic_Mail
            clinicData[indexData]['ClinicState'] = clinic.ClinicState
            clinicData[indexData]['Clinic_Country'] = clinic.Clinic_Country
            clinicData[indexData]['Clinic_City'] = clinic.Clinic_City
            clinicData[indexData]['Clinic_Street'] = clinic.Clinic_Street
            clinicData[indexData]['Clinic_Apartment'] = clinic.Clinic_Apartment
            clinicData[indexData]['Clinic_Phone_num'] = clinic.Clinic_Phone_num
            clinicData[indexData]['Clinic_Code'] = clinic.Clinic_Code
            clinicData[indexData]['Is_Approving_Clinic'] = clinic.Is_Approving_Clinic

            initiateClinicData[indexInit]['Clinic_Name'] = clinic.Clinic_Name
            initiateClinicData[indexInit]['Clinic_Phone_num'] = clinic.Clinic_Phone_num
            initiateClinicData[indexInit]['Clinic_Mail'] = clinic.Clinic_Mail
            initiateClinicData[indexInit]['ClinicState'] = clinic.ClinicState
            initiateClinicData[indexInit]['Clinic_Country'] = clinic.Clinic_Country
            initiateClinicData[indexInit]['Clinic_City'] = clinic.Clinic_City
            initiateClinicData[indexInit]['Clinic_Street'] = clinic.Clinic_Street
            initiateClinicData[indexInit]['Clinic_Apartment'] = clinic.Clinic_Apartment
            initiateClinicData[indexInit]['Clinic_Phone_num'] = clinic.Clinic_Phone_num
            initiateClinicData[indexInit]['Clinic_Code'] = clinic.Clinic_Code
            initiateClinicData[indexInit]['Is_Approving_Clinic'] = clinic.Is_Approving_Clinic


            let _pdata = JSON.parse(JSON.stringify(clinicData));
            let _idata = JSON.parse(JSON.stringify(initiateClinicData));
            state = {
                ...state,
                initiateClinicData:_idata,
                clinicData : _pdata
            };
            break;
        }
        default:
            break;
    }
    return state;
};
export default clinicTableDataReducer;
